<template>
<v-list-item-avatar v-if="isNoteEmpty" class="my-0">
  <v-icon small>{{ printIcon }}</v-icon>
</v-list-item-avatar>
<v-tooltip v-else bottom>
  <template v-slot:activator="{ on }">
    <v-list-item-avatar v-on="on" class="my-0">
      <v-badge left color="secondary">
        <template v-slot:badge>
          <v-icon x-small color="white">fa-comment-alt</v-icon>
        </template>
        <v-icon small>{{ printIcon }}</v-icon>
      </v-badge>
    </v-list-item-avatar>
  </template>
  <span>{{ printNote }}</span>
</v-tooltip>
</template>

<script>
export default {
  name: 'abt-item-avatar',
  props: [
    'icon',
    'note'
  ],
  data () {
    return {
      config: {
        tip: {
          active: false
        }
      }
    }
  },
  components: {
  },
  computed: {
    isNoteEmpty () {
      return !this.$props.note
    },
    printNote () {
      return this.$props.note || ''
    },
    printIcon () {
      return this.$props.icon || ''
    }
  }
}
</script>